import { render, staticRenderFns } from "./MappingSortableHeader.vue?vue&type=template&id=75f98f5e"
import script from "./MappingSortableHeader.vue?vue&type=script&lang=js"
export * from "./MappingSortableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports